// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const galvantula: PokeData = {
  "id": 596,
  "name": "galvantula",
  "height": 8,
  "weight": 143,
  "base_experience": 165,
  "types": [
    PokeType.BUG,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "absorb",
    "string-shot",
    "thunder-wave",
    "agility",
    "screech",
    "leech-life",
    "slash",
    "spider-web",
    "fury-cutter",
    "signal-beam",
    "gastro-acid",
    "sucker-punch",
    "bug-buzz",
    "discharge",
    "bug-bite",
    "electro-ball",
    "electroweb",
    "sticky-web"
  ],
  "moves": [
    "string-shot",
    "bug-buzz",
    "bug-bite",
    "sticky-web",
    "pin-missile",
    "leech-steal",
    "thunder-shock",
    "lunge",
    "thunder-fang",
    "pin-rush",
    "thunderbolt",
    "electric-terrain",
    "volt-crash"
  ],
  "evolution_chain": {
    "id": 303,
    "item": null,
    "species": [
      {
        "name": "joltik",
        "order": 596,
        "types": [
          PokeType.BUG,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "galvantula",
        "order": 597,
        "types": [
          PokeType.BUG,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 595,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 160,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
